import httpClient from '@/api/http-client';
import getFormData from '@/util/form-data';

const endpoint = 'api/locations';

const locationsService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  create: (location) => httpClient.post(`${endpoint}`, location),

  update: (location) => httpClient.put(`${endpoint}/${location.id}`, location),

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  delete: (location) => httpClient.delete(`${endpoint}/${location.id}`),

  checkIn: (payload) => {
    const formData = getFormData(payload);
  
    return httpClient.post(`${endpoint}/${payload.id}/check-in`, formData)
  },

  changeOrder: (payload) => httpClient.post(`${endpoint}/change-order`, {
    ...payload,
  }),

  changeNumber: (location) => httpClient.put(`${endpoint}/${location.id}/change-number`, {
    number: location.number
  }),

  generatePdfList: (params) => httpClient({
    url: `${endpoint}/generate-pdf-list`,
    method: 'GET',
    responseType: 'blob',
    params,
  }),

  changesHistory: (id) => httpClient.get(`${endpoint}/${id}/changes-history`)
};

export default locationsService;
